import { FC } from 'react';

import Table from 'modules/_shared/Table';

import CustomMovementsSectionTableHeader from './CustomMovementsSectionTableHeader';
import CustomMovementsSectionTableBody from './CustomMovementsSectionTableBody';

const CustomMovementsSectionTable: FC = () => {
  const tableContent = (
    <>
      <CustomMovementsSectionTableHeader />
      <CustomMovementsSectionTableBody />
    </>
  );

  return <Table content={tableContent} />;
};

export default CustomMovementsSectionTable;
